module.exports = __webpack_public_path__ + "img/text-response.a1c9d760.png";